/**
 * Shared Button classes for sprint-style tab toggles (PM reporting).
 * Uses theme tokens (not hardcoded legacy hex) so light/dark and future palette tweaks stay consistent.
 * Inactive: card surface; active: foreground-on-background "inverted" chip.
 *
 * @param fixedHeight — `h-[50px]` for report/product togglers; omitted for generic/sprint
 */
export function togglerTabButtonClass(isActive: boolean, options?: { fixedHeight?: boolean }): string {
  const h = options?.fixedHeight ? 'h-[50px] ' : '';
  // Never squeezed or wrapped: a row of them scrolls sideways instead (see the togglers' `overflow-x-auto`).
  const base = '!shrink-0 whitespace-nowrap !rounded-lg !px-4 !py-2 !shadow-none ';
  const state = isActive
    ? '!border-0 !bg-foreground !text-background hover:!bg-foreground hover:!text-background'
    : '!border-0 !bg-card !text-foreground hover:!bg-card hover:!text-foreground';
  return (h + base + state).trim();
}
